import React from 'react';
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Icon from 'material-ui/Icon'
import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'

import { withStyles } from 'material-ui/styles'
import styles from './styles'

import { ModalHeader, ModalContents, ModalFooter } from '../../common/modal'

class ImportTest extends React.Component {

    handleClose = () => {
        this.props.onClose()
    }


    render() {
        const {
            translate,
            upload,
            uploadComet,
            classes
        } = this.props;

        return (
            <Modal open={true} onClose={this.handleClose.bind(this)}>
                <div className={classes.root}>
                    <Paper className={classes.modal}>

                        <ModalHeader>
                            <Typography type="headline" color="inherit" className={classes.modalHeader} >
                                {translate('general_import')}
                            </Typography>
                            <Button
                                className={classes.close}
                                onClick={this.handleClose}
                            >
                                <Icon>clear</Icon>
                            </Button>
                        </ModalHeader>

                        <ModalContents>

                            <Grid container spacing={8}>
                                <Grid item xs={8}>
                                    <Button
                                        className={classes.submit}
                                        raised
                                        color="primary"
                                        type="submit"
                                        onClick={upload}
                                    >
                                        {translate('tooltip_import_lantek')}
                                    </Button>
                                </Grid>
                                <Grid item xs={4} />
                                <Grid item xs={8}>
                                    <Button
                                        className={classes.submit}
                                        raised
                                        color="primary"
                                        type="submit"
                                        onClick={uploadComet}
                                    >
                                        {translate('job_upload_comet_title')}
                                    </Button>
                                </Grid>
                                <Grid item xs={4} />
                            </Grid>
                        </ModalContents>
                    </Paper>
                </div>
            </Modal >
        )
    }
}

export default withStyles(styles)(ImportTest)